// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
import {
  Slider
} from 'element-ui';
import Notifications from 'vue-notification';
import VeeValidate from 'vee-validate';

//import './assets/css/styles.min.css'

Vue.config.productionTip = false;
Vue.use(VeeValidate);
Vue.use(Notifications);
Vue.use(Slider);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
  created() {
    //check if the cart is not empty see the content of localstorage
    this.$store.dispatch('loadCart');
  },
  /*mounted() {
    // You'll need this for renderAfterDocumentEvent.
    document.dispatchEvent(new Event('render-event'))
  }*/
});



// WEBPACK FOOTER //
// ./src/main.js